import numeral from "numeral";
import { formatAmount } from "./text.utils";

export const isLiterValid = (liter) => {
  const regex = new RegExp(/[^0-9]/);
  const val = liter.toString().split(".");

  if (val.length > 2) {
    return false;
  }

  if (!val[1]) {
    val.push("0");
  }

  if (val[1].length > 3) {
    return false;
  }

  return !regex.test(val[0]) && !regex.test(val[1]);
};

export const isPesoValid = (peso, decimalPlaces = 2) => {
  if (peso === "-") return true;

  const val = peso.toString().split(".");
  if (val.length > 2) return false;

  const [intPart, decimalPart = ""] = val;

  if (decimalPart.length > decimalPlaces) return false;

  return /^\d*$/.test(intPart) && /^\d*$/.test(decimalPart);
};

export const isAmountValid = (amount, decimalPlaces = 2) => {
  if (amount === "-") return true;

  const val = amount.toString().split(".");
  if (val.length > 2) return false;

  const [intPart, decimalPart = ""] = val;

  // Accept "-1." or similar
  if (decimalPart.length > decimalPlaces) return false;

  return /^-?\d*$/.test(intPart) && /^\d*$/.test(decimalPart);
};

export const formatNumber = (num, decimalPlaces = 3) => {
  const numStr = String(num);

  const [integerPart, decimalPart = ""] = numStr.split(".");

  let finalDecimal = decimalPart.padEnd(decimalPlaces, "0").slice(0, decimalPlaces);

  const formattedInteger = Number(integerPart).toLocaleString("en", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  if (decimalPlaces === 0) {
    return formattedInteger;
  }
  return `${formattedInteger}.${finalDecimal}`;
};

export const parseNumber = (num) => {
  return numeral(num).value();
};

export const roundUp = (num, format = "00.000") => {
  return Number(numeral(num).format(format));
};

export const formatCurrency = (num, prefix = "₱", decimalPlace = 2) => {
  return `${prefix} ${formatNumber(num, decimalPlace)}`;
};

export const formatCurrencyWithoutDecimal = (num, prefix = "₱") => {
  return `${prefix} ${num}`;
};

export const formatPesoWithDecimalRange = (num, decimalPlaces = 2) => {
  return `₱ ${formatNumber(num, decimalPlaces)}`;
};

export const formatVolume = (num, suffix = "L", decimalPlace = 3) => {
  return `${formatNumber(num, decimalPlace)} ${suffix}`;
};

export const formatDecimal = (value, decimalPlace = 3) => {
  const number = parseFloat(value);

  if (isNaN(number)) return "";

  if (number % 1 !== 0) {
    return number.toFixed(decimalPlace);
  } else {
    return number.toString();
  }
};

export const formatVolumeWithoutDecimal = (num, suffix = "L") => {
  return `${num} ${suffix}`;
};

export const parseLiter = (num) => {
  return parseNumber(num.toString().replace(" L", ""));
};

export const formatAmountPerLiter = (num) => {
  return `${formatAmount(num)} / L`;
};

export const formatBytes = (bytes, decimals) => {
  if (bytes === 0 || !bytes) return "0 Bytes";
  let k = 1024,
    dm = decimals || 2,
    sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const truncate = (num, decimals) => {
  const factor = Math.pow(10, decimals);
  return Math.trunc(num * factor) / factor;
};
